import generateTypes from '../utils/generateTypes';

export const GET_LOCATIONS = generateTypes('GET_LOCATIONS');
export const RESET_LOCATIONS = generateTypes('RESET_LOCATIONS');
export const GET_POINTR_POINT_OF_INTEREST_OPTIONS = generateTypes(
    'GET_POINTR_POINT_OF_INTEREST_OPTIONS'
);
export const GET_POINTR_BUILDING_OPTIONS = generateTypes(
    'GET_POINTR_BUILDING_OPTIONS'
);
export const CLEAR_POINTR_POI_OPTIONS = 'CLEAR_POINTR_POI_OPTIONS';
export const SET_POINTR_SITE_ID_ERROR = 'SET_POINTR_SITE_ID_ERROR';
